import React from 'react';
import PropTypes from 'prop-types';
import Section from 'components/Section';
import fieldSelection from 'components/Forms/Fields';
import styles from './index.module.scss';
import ImageUpload from 'components/Forms/Fields/ImageUpload';
import cn from 'classnames';

const SubPanel = ({
  subFields,
  subPanelHeader,
  props,
  hidden,
  imageRequired,
  imageType,
  styleInfo,
}) => {
  return (
    <Section
      text={subPanelHeader}
      className={
        hidden
          ? styles.hidden
          : cn(styles.show, { [styles.noBorder]: styleInfo.noBorder })
      }
      contentStyle={styles.sectionContent}
    >
      <div className={cn(styles.fixedLeft, { [styles.hidden]: hidden })}>
        {imageRequired && (
          <ImageUpload
            type={imageType}
            error={props.submitCount > 0 && props.errors['subPanelImage']}
            name="subPanelImage"
            id="subPanelImage"
            value={props.values['subPanelImage']}
            onChange={image => props.setFieldValue('subPanelImage', image)}
          />
        )}
      </div>
      <div
        className={cn(styles.inputs, {
          [styles.fieldsInColumn]: styleInfo.showFieldInColumn,
        })}
      >
        {subFields.map((item, key) => fieldSelection({ item, key, props }))}
      </div>
    </Section>
  );
};

SubPanel.propTypes = {
  subFields: PropTypes.array,
  subPanelHeader: PropTypes.string,
  props: PropTypes.object,
  hidden: PropTypes.bool,
  imageRequired: PropTypes.bool,
  imageType: PropTypes.oneOf(['Profile', 'Establishment']),
  submitCount: PropTypes.number,
  errors: PropTypes.object,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
  styleInfo: PropTypes.object,
};
SubPanel.defaultProps = {
  imageRequired: true,
  styleInfo: {
    noBorder: false,
    showFieldInColumn: false,
  },
};

export default SubPanel;
